import useFetch from "v4/hooks/useFetch";
import {useEffect} from "react";

/**
 * @param {string} url
 * @param {any} [dependencies]
 * @param {RequestInit & {[notoken]: boolean}} [config]
 * @returns {import("v4/hooks/useFetch").FetchState}
 **/
export default function useAutoFetch(url, dependencies = null, config = {}) {
    const [state, fetch] = useFetch();

    useEffect(() => {
        fetch({url, config});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetch, url, dependencies]);

    return state;
}
